/**
 * Expose forEach
 */

module.exports = forEach

/**
 * forEach
 */

function forEach (fn, obj) {
  if (!obj) return

  var keys = Object.keys(obj)

  for (var i = 0, len = keys.length; i < len; ++i) {
    var key = keys[i]
    fn.call(this, obj[key], key, i)
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/@f/foreach-obj/lib/index.js
// module id = ./node_modules/@f/foreach-obj/lib/index.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons